exports = module.exports = require("../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /Users/balazskaxd/dev/rkk/rkk-webapp/~/css-loader!/Users/balazskaxd/dev/rkk/rkk-webapp/~/antd/lib/locale-provider/style/index.css
// module id = 849
// module chunks = 20